import { APIImobsaleUrl, APICadimo5Url } from "../../services/constants";
export const API_VENDAS = `${APIImobsaleUrl}`;
export const API_CADIMO5 = `${APICadimo5Url}`;

export const PRICE_RENT_INITIAL = [0, 100000];
export const PRICE_SALE_INITIAL = [0, 10000000];
export const AREA_INITIAL = [0, 10000];

export const STEP_AREA = 50;
export const STEP_RENT = 500;
export const STEP_SALE = 50000;
